import { deviceUtil } from "@repo/lib-common";
import { AdLoadingStrategyTypeEnum, AdSizes, AdUnit, AdUnitSpecialUseCaseEnum, AdUnitTypeEnum } from "@repo/lib-domain-tag";

export const desktopOutOfPageAdUnit = [
    AdUnit.builder(AdUnitTypeEnum.outOfPage_Interstitial)
        .setDeviceType(deviceUtil.DeviceTypeInfo.desktopDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.none)
        .setSpecialUseCaseIndex(0)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_popup")
        .setDivId("div-sozcu_popup")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.general_1x1)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(false)
        .build()
];


export const mobileOutOfPageAdUnit = [
    AdUnit.builder(AdUnitTypeEnum.outOfPage_Interstitial)
        .setDeviceType(deviceUtil.DeviceTypeInfo.mobileDevices)
        .setSpecialUseCase(AdUnitSpecialUseCaseEnum.none)
        .setSpecialUseCaseIndex(0)
        .setIsEnabled(true)
        .setAdUnitPath("/66738120/sozcu_mobile_interstial")
        .setDivId("div-sozcu_popup")
        .setDivStyleAfterRequest('')
        .setLoadingStrategy(AdLoadingStrategyTypeEnum.trigger)
        .setSizes(AdSizes.general_1x1)
        .setIsAutoRefreshEnabled(false)
        .setIsPrebidEnabled(false)
        .build()
];